import { render, staticRenderFns } from "./MonitorGovernment.vue?vue&type=template&id=7246f47c&scoped=true&"
import script from "./MonitorGovernment.vue?vue&type=script&lang=js&"
export * from "./MonitorGovernment.vue?vue&type=script&lang=js&"
import style0 from "./MonitorGovernment.vue?vue&type=style&index=0&id=7246f47c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7246f47c",
  null
  
)

export default component.exports